import { useState } from "react";
import { useRouter } from "next/router";

import { gql } from '@apollo/client';
import { useFormik } from "formik";
import { useLoggedGeladaMutation } from "@netfront/gelada-identity-library";
import { Button, Input } from "@netfront/ui-library";
import * as yup from 'yup';

import { IVerifyPhoneTokenForm } from "./VerifyPhoneTokenForm.interfaces";
import { useAddCustomEvent } from "@/hooks";
import Link from "next/link";

export const VerifyPhoneTokenForm = () => {
  const { push } = useRouter();
  const { handleAddCustomEvent } = useAddCustomEvent();

  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);

  const [commitChange] = useLoggedGeladaMutation({
    mutation: gql`
      mutation($token: String!) {
        user {
          commitChange(token: $token)
        }
      }
    `,
    options: {
      onCompleted: async () => {
        await handleAddCustomEvent({ 
          projectId: String(process.env.REACT_APP_PROJECT_ID), 
          type: `Phone verification: success` 
        });

        push('/dashboard');
      },
      onError: () => {
        setIsFormSubmitting(false)
      }
    }
  });

  const formik = useFormik<IVerifyPhoneTokenForm>({
    initialValues: {
      token: ''
    },
    validationSchema: yup.object().shape({
      token: yup.string().required('Enter code provided to your phone'),
    }),
    onSubmit: async ({ token }: IVerifyPhoneTokenForm) => {
      setIsFormSubmitting(true);

      commitChange({ 
        variables: { 
          token 
        } 
      });
    },
  });

  const { errors, touched, handleBlur, handleChange, handleSubmit, values } = formik;

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full px-4">
          <Input
            errorMessage={touched.token && errors.token ? errors.token : ''}
            id="token"
            labelText="Enter the code provided via SMS"
            name="token"
            placeholder="Enter code"
            type="text"
            value={values.token}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <div className="flex justify-center">
            <Link 
              className="flex bg-transparent color-green-500 border-none font-body weight-600 text-base mb-4 pointer mx-auto"
              href={'/user/verify-phone'}
            >
              Correct your number
            </Link>
          </div>
        </div>
      </div>

      <Button
        additionalClassNames="w-full"
        text={'Enter code'}
        type="submit"
        isLoading={isFormSubmitting}
      />
    </form>
  );
};